/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Badge, makeStyles, Theme, Typography, TypographyProps } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  statusIndicator: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiBadge-badge': {
      transform: 'initial',
      position: 'initial',
      order: -1,
      marginRight: theme.spacing(1),
      height: theme.spacing(1.5),
      minWidth: theme.spacing(1.5),
      borderRadius: theme.spacing(1.5) / 2,
    },
  },
  default: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  success: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.success.main,
    },
  },
  error: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  info: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.info.dark,
    },
  },
  warning: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  primary: {
    '& > .MuiBadge-badge': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  inherit: {
    '& > .MuiBadge-badge': {
      backgroundColor: 'currentColor',
    },
  },
}));

export type StatusProps = {
  statusColor?: any;
  'data-testid'?: string | undefined;
  statusLabel?: string | undefined;
  textProps?: TypographyProps & { 'data-testid'?: string | undefined };
};

export const StatusIndicator = ({ statusColor, statusLabel, textProps, ...props }: StatusProps): JSX.Element => {
  const classes = useStyles();

  const severity = (
    statusColor: StatusProps,
  ): 'success' | 'error' | 'warning' | 'info' | 'default' | 'primary' | 'inherit' => {
    switch (statusColor) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      case 'primary':
        return 'primary';
      case 'inherit':
        return 'inherit';
      default:
        return 'default';
    }
  };

  return (
    <Badge
      data-testid={props['data-testid']}
      className={clsx(classes.statusIndicator, classes[severity(statusColor)])}
      variant="dot"
    >
      <Typography variant="inherit" {...textProps}>
        {statusLabel}
      </Typography>
    </Badge>
  );
};
